import * as React from "react";
import { Stack, Strong, Text } from "@origin-digital/ods-core";
import dayjs from "dayjs";

const DATE_FORMAT = "DD/MM/YY";
const TIME_FORMAT = "hh:mma";

interface RequestorInfoProps {
  requesterName: string;
  submittedDateTime: Date | string;
  behaviourType?: "lodged" | "submitted";
  actionType?: string;
}

const RequestorInfo: React.FC<RequestorInfoProps> = ({
  requesterName,
  submittedDateTime,
  behaviourType = "lodged",
  actionType,
}) => {
  const dateTime =
    submittedDateTime instanceof Date
      ? submittedDateTime
      : new Date(submittedDateTime);
  return (
    <Stack space="xsmall">
      <Text>
        <Strong>{requesterName}</Strong> {behaviourType}{" "}
        {actionType ? `${actionType} ` : ""}on{" "}
        {dayjs(dateTime).format(DATE_FORMAT)} at{" "}
        {dayjs(dateTime).format(TIME_FORMAT)}.
      </Text>
    </Stack>
  );
};

export default RequestorInfo;
